"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Icon = _interopRequireDefault(require("../Icon"));

var _styled = require("./styled");

var BUTTON_SIZE_TO_ICON_MAP = {
  small: 'xxsmall',
  normal: 'normal',
  large: 'normal'
};

var cloneIconWithSize = function cloneIconWithSize(icon, size) {
  var sizeByMap = BUTTON_SIZE_TO_ICON_MAP[size];

  if (_react["default"].isValidElement(icon)) {
    return _react["default"].cloneElement(icon, {
      size: icon.props.size || sizeByMap
    });
  } else if (typeof icon === 'string') {
    return _react["default"].createElement(_Icon["default"], {
      name: icon,
      size: sizeByMap,
      inheritColor: true
    });
  }
};

var RenderedComponent = function RenderedComponent(_ref) {
  var children = _ref.children,
      href = _ref.href,
      props = (0, _objectWithoutProperties2["default"])(_ref, ["children", "href"]);
  return href ? _react["default"].createElement(_styled.StyledButtonLink, (0, _extends2["default"])({
    href: href
  }, props), children) : _react["default"].createElement(_styled.StyledButton, props, children);
};

var Button = function Button(_ref2) {
  var text = _ref2.children,
      variant = _ref2.variant,
      disabled = _ref2.disabled,
      size = _ref2.size,
      icon = _ref2.icon,
      leftIcon = _ref2.leftIcon,
      rightIcon = _ref2.rightIcon,
      props = (0, _objectWithoutProperties2["default"])(_ref2, ["children", "variant", "disabled", "size", "icon", "leftIcon", "rightIcon"]);
  return _react["default"].createElement(RenderedComponent, (0, _extends2["default"])({}, props, {
    size: size,
    variant: variant,
    isIconOnly: Boolean(icon),
    hasLeftIcon: Boolean(leftIcon),
    hasRightIcon: Boolean(rightIcon),
    disabled: disabled
  }), leftIcon ? _react["default"].createElement(_styled.IconWrap, {
    size: size,
    left: true
  }, cloneIconWithSize(leftIcon, size)) : null, icon ? _react["default"].createElement(_styled.IconWrap, {
    size: size
  }, cloneIconWithSize(icon, size)) : _react["default"].createElement(_styled.StyledButtonText, {
    size: size,
    hasLeftIcon: Boolean(leftIcon),
    hasRightIcon: Boolean(rightIcon)
  }, text), rightIcon ? _react["default"].createElement(_styled.IconWrap, {
    size: size,
    right: true
  }, cloneIconWithSize(rightIcon, size)) : null);
};

Button.defaultProps = {
  variant: 'primary',
  size: 'normal'
  /* eslint-disable react/require-default-props */

};
Button.propTypes = {
  size: _propTypes["default"].oneOf(Object.keys(_styled.SIZES)),
  variant: _propTypes["default"].string,
  className: _propTypes["default"].string,
  children: _propTypes["default"].node,
  disabled: _propTypes["default"].bool,
  icon: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].element]),
  leftIcon: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].element]),
  rightIcon: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].element])
};
RenderedComponent.propTypes = {
  children: _propTypes["default"].node,
  href: _propTypes["default"].string
};
var _default = Button;
exports["default"] = _default;